import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../helpers/common'
import { register } from '../../../helpers/reducerRegistry'
import { valByKeyWithDot } from '../../../helpers/value'
import { getCompanyHighlight, getCompanyInfoDetail } from './thunk'

const initialState = {
  companyHighlight: {},
  companyInfoDetail: {},

  loading: {
    companyHighlight: true,
    companyInfoDetail: true,
  },
}

export const slice = createSlice({
  name: 'companyAnalysis/companyProfile',
  initialState,
  reducers: {
    resetStore(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
  },
  extraReducers: (builder) => {
    //getCompanyHighlight
    builder.addCase(getCompanyHighlight.pending, (state) => {
      state.loading.companyHighlight = true
    })
    builder.addCase(getCompanyHighlight.fulfilled, (state, action) => {
      state.companyHighlight = action.payload
      state.loading.companyHighlight = false
    })
    builder.addCase(getCompanyHighlight.rejected, (state, action) => {
      state.loading.companyHighlight = action.payload.loading
    })
    //getCompanyInfoDetail
    builder.addCase(getCompanyInfoDetail.pending, (state) => {
      state.loading.companyInfoDetail = true
    })
    builder.addCase(getCompanyInfoDetail.fulfilled, (state, action) => {
      state.companyInfoDetail = action.payload
      state.companyInfoDetail.vsicIndustryById = keyBy(
        action.payload.vsicIndustries,
        'vsicId',
      )
      state.companyInfoDetail.icbIndustryById = keyBy(
        action.payload.icbIndustries,
        'icbId',
      )
      state.companyInfoDetail.companyBoardOfDirectorById = keyBy(
        action.payload.companyBoardOfDirector,
        'personId',
      )
      state.companyInfoDetail.companyBoardOfManagementById = keyBy(
        action.payload.companyBoardOfManagement,
        'personId',
      )
      state.loading.companyInfoDetail = false
    })
    builder.addCase(getCompanyInfoDetail.rejected, (state, action) => {
      state.loading.companyInfoDetail = action.payload.loading
    })
  },
})

export const selectCompanyHighlight = (callback) => (state) => {
  const data = state[slice.name].companyHighlight
  return callback ? callback(data) : data
}

export const selectCompanyInfoDetail = (callback) => (state) => {
  const data = state[slice.name].companyInfoDetail
  return callback ? callback(data) : data
}

export const selectVSICById = (id, attr) => (state) =>
  valByKeyWithDot(
    state[slice.name].companyInfoDetail.vsicIndustryById[id],
    attr,
  )
export const selectICBById = (id, attr) => (state) =>
  valByKeyWithDot(state[slice.name].companyInfoDetail.icbIndustryById[id], attr)
export const selectCompanyBoardOfDirectorById = (id, attr) => (state) =>
  valByKeyWithDot(
    state[slice.name].companyInfoDetail.companyBoardOfDirectorById[id],
    attr,
  )
export const selectCompanyBoardOfManagementById = (id, attr) => (state) =>
  valByKeyWithDot(
    state[slice.name].companyInfoDetail.companyBoardOfManagementById[id],
    attr,
  )

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return state[slice.name].loading[type]
}

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
